<template>
  <div class="wsqleft-wrapper">
    <div class="wsqleft">
      <div class="left-title" :style="{fontSize:height>1000?'30px':'24px'}">
        社区简介
      </div>
      <div class="box shequ" :style="{paddingTop:height*0.019+'px',paddingBottom:height*0.019+'px'}">
        <div class="iconfont icon-chengyuanqunzu" style="font-size: 30px;padding:9px 5px 0 0"></div>
        <div>居民数：<span style="font-size: 35px">{{info.totalNumber}}</span><span style="font-size: 16px">人</span></div>
      </div>

      <y-scroll :contentArr="leftScroll" :height="height*0.285" :lineNum="1" :width="width*0.234" :time="5000">
        <div slot="scroll" slot-scope="props" class="scroll-wrapper">
          <div v-if="props.todo.text" class="wsq-jianjie">
            <p  class="shequ-span" :style="{fontSize:height>1000?'25px':'23px'}">
              {{props.todo.text}}
            </p>
          </div>
          <div v-else-if="props.todo.img" style="padding-top:1px">
            <img class='scroll-pic' :src='props.todo.img' :style="{height: height*0.285-5+'px'}" />
          </div>
        </div>
      </y-scroll>

      <div class="wsq-ma" v-if="info.qrcodeUrl" :style="{bottom:height*0.049+'px',height: height*0.215+'px',width:height*0.215+'px'}">
        <img :src="info.qrcodeUrl" style="height: 100%;width: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
  import yScroll from '../../../components/yScroll'
  export default {
    components: {
      yScroll
    },
    data () {
      return {

      }
    },
    props:{
      height:Number,
      width:Number,
      info:{
        type:Object,
        default:{}
      },
      leftScroll:{
        type: Array,
        default: []
      }
    },
    mounted () {

    }
  }
</script>

<style scoped>
  .wsqleft-wrapper{
    width: 23.5%;
    height: 82.75%;
    margin: 0 2.08%
  }
  .wsqleft{
    background-color: rgba(255,255,255,0.5);
    height: 100%;
    position: relative;
    border: 3px solid #fff;
    position: relative;
  }
  .left-title{
    color: #fff;
    height:8.33%;
    width:55.55%;
    position: absolute;
    top:-5.5%;
    left:50%;
    transform: translateX(-50%);
    background: #ff6344;
    border-radius: 25px;
    box-shadow: inset 0px 0px 10px 3px #fa513a;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .shequ{
    color:#ff4500;
    /*padding: 35px 0;*/
    justify-content: center;
    font-size:24px
  }
  .wsq-jianjie{
    letter-space:1px;
    color:#333;
    line-height: 2;
    padding: 0 8.88%;
    font-size: 25px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
  }
  .wsq-ma{
    /*height: 220px;*/
    /*width: 220px;*/
    position: absolute;
    left:50%;
    transform: translateX(-50%)
  }
  .scroll-wrapper{
    padding: 0 15px
  }
  .shequ-span{
    /*color: #676767;*/
    /*text-indent:50px;*/
    /*line-height: 40px;*/
  }
  .scroll-pic{
    width: 100%;
    /*height: 100%;*/
  }
</style>
